import { CARDS_CATALOG_IDS, PREMIOS_CATALOG_IDS } from "utils/constants";
import { api } from "./api";

export interface IPrizes {
  _id: string;
  player: string;
  name: string;
  catalogId: string;
  description: string;
  image: string;
}

/**
 * Itens da vitrine de cards: os prêmios e os cards que eles exigem.
 *
 * O catálogo completo carrega junto as ~1.000 experiências do Mercado de
 * Estrelas, que esta página descarta. Filtrar no servidor mantém a resposta
 * pequena e evita o timeout intermitente do gateway — que chega ao navegador
 * disfarçado de erro de CORS, porque a resposta de erro vem sem os cabeçalhos.
 */
export async function getPremiosECards() {
  const payload = [
    {
      $match: {
        catalogId: { $in: [...PREMIOS_CATALOG_IDS, ...CARDS_CATALOG_IDS] },
      },
    },
  ];

  try {
    const { data } = await api.post("/database/catalog_item/aggregate", payload);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    return [];
  }
}

export async function getExperienceCatalog() {
  try {
    const { data } = await api.get("database/experiencias__c");
    return data;
  } catch (error) {
    return error;
  }
}

export async function getVirtualGood(_id: string) {
  try {
    const { data } = await api.get(`virtualgoods/item/${_id}`);
    return data;
  } catch (error) {
    return error;
  }
}

export async function purchaseItem(item: string, player: string, recaptchaToken?: string) {
  try {
    const payload: any = {
      item,
      player,
      extra: {}
    };
    if (recaptchaToken) {
      payload.extra.authorization = recaptchaToken;
    }
    const { data } = await api.post("virtualgoods/purchase", payload);
    return data;
  } catch (error) {
    return error;
  }
}

export async function getPrizes(player: string, unidade: string) {
  try {
    const { data } = await api.post("find/prizes", {
      player,
      unidade,
    });
    return (Array.isArray(data) ? data : []) as IPrizes[];
  } catch (error) {
    return [] as IPrizes[];
  }
}

export async function getListaResgates(startDate: string, endDate: string) {
  const payload = { startDate, endDate };

  const { data } = await api.post("/find/resgates_itens", payload, {
    headers: {
      range: "items=0-10000",
    }
  });
  return data;
}

export async function getCardsId() {
  const payload = [
    {
      "$match": {
        "catalogId": {
          "$in": CARDS_CATALOG_IDS
        }
      }
    },
    {
      "$group": {
        "_id": null,
        "ids": {
          "$push": "$_id"
        }
      }
    }
  ];

  const { data } = await api.post("/database/catalog_item/aggregate", payload);
  return data;
}


export async function getTransparencia() {
  const payload = [{ $sort:{ "created": -1} }];

  const { data } = await api.post("/database/transparencia_loja__c/aggregate", payload);
  return data;
}

export async function getCatalogItems(catalogId: string) {
  const payload = [
    {
        "$match": {
            "techniques": {
                "$in": ["GT16"]
            }
        }
    },
    {
        "$match": {
            "catalogId": catalogId,
            "active": true
        }
    },
    {
        "$lookup": {
            "from": "achievement",
            "let": {
                "item": "$_id"
            },
            "pipeline": [
                {
                    "$match": {
                        "$expr": {
                            "$eq": ["$item", "$$item"]
                        }
                    }
                },
                {
                    "$group": {
                        "_id": "$item",
                        "total": {
                            "$sum": "$total"
                        }
                    }
                }
            ],
            "as": "redeem"
        }
    },
    {
        "$addFields": {
            "redeem": {
                "$ifNull": [
                    { "$arrayElemAt": ["$redeem.total", 0] },
                    0
                ]
            }
        }
    },
    {
        "$sort": {
            "created": -1
        }
    }
  ];

  const { data } = await api.post("/database/catalog_item/aggregate", payload);
  return data;
}